import { render, staticRenderFns } from "./ButtonTemplateItem.vue?vue&type=template&id=fd12b9b2&scoped=true"
import script from "./ButtonTemplateItem.vue?vue&type=script&lang=js"
export * from "./ButtonTemplateItem.vue?vue&type=script&lang=js"
import style0 from "./ButtonTemplateItem.vue?vue&type=style&index=0&id=fd12b9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd12b9b2",
  null
  
)

export default component.exports